import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { debounce } from '@ifeng-fe/ui_base';
import Grounds from '@ifeng-fe/three_terminal/es/base/grounds';
import styles from './index.css';
import GlobalNews from '../globalnews';
import AllNews from '../allnews';
import { getDateWeekDay } from '@ifeng-fe/container_channel/common/client/spring/mobile/utils/timeUnit';
import {
    getFinanceSelectedData,
    getFinanceShareIdData,
    getFinanceNewShareIdData,
    getFinanceMoreShareIdData,
} from '../../../../services/api';
import { getQuery } from '@src/utils/utils';

if (!window.IntersectionObserver) {
    require('@ifeng-fe/container_channel/common/client/spring/mobile/utils/interSectionObserverPolyfill');
}

class TabList extends React.PureComponent {
    state = {
        loading: false,
        liveData: [],
        liveLastid: '',
        livePrevid: '',
        globalData: [],
        globalDataEnd: false,
        globalLastid: '',
        curId: 1,
        tabNavArr: [
            {
                id: 1,
                name: '全部',
            },
            {
                id: 2,
                name: '财经精选',
            },
        ],
        time: 60 * 1000,
        currentGlobalPage: 0,
        scrollTop: 0,
        stickShow: false,
        dateStr: '',
    };

    hasRequestSelectedData = false;
    handleWindowScrollDebounce = null;
    ref = React.createRef();
    fixTabRef = React.createRef();
    fixTimeRef = React.createRef();

    getGlobalData = async () => {
        if (!this.state.loading && !this.state.globalDataEnd) {
            this.setState(
                {
                    loading: true,
                },
                async () => {
                    const getFinanceData = await getFinanceSelectedData(
                        '240190',
                        this.state.currentGlobalPage * 20,
                        20,
                    );

                    if (getFinanceData && getFinanceData.data) {
                        this.hasRequestSelectedData = true;
                        this.setState({
                            globalData: [...this.state.globalData, ...getFinanceData.data],
                            globalDataEnd: getFinanceData.data.length < 20,
                            currentGlobalPage: this.state.currentGlobalPage + 1,
                            loading: false,
                        });
                    }
                },
            );
        }
    };

    handleTab(curNum) {
        this.setState(
            {
                curId: curNum,
            },
            () => {
                if (!this.hasRequestSelectedData) {
                    this.getGlobalData();
                }
            },
        );
    }

    // 窗口高度
    getWindowHeight = () => {
        let windowHeight = 0;

        if (document.compatMode === 'CSS1Compat') {
            windowHeight = document.documentElement.clientHeight;
        } else {
            windowHeight = document.body.clientHeight;
        }

        return windowHeight;
    };

    handleScrollMore = () => {
        const clientHeight = this.getWindowHeight();
        const scrollH = document.body.scrollHeight;
        const scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset;
        const bottom = scrollH - clientHeight - scrollTop;
        const fixTimeHeight = (this.fixTimeRef.current && this.fixTimeRef.current.offsetHeight) || 0;
        const boundingHeight = this.fixTabRef.current.offsetHeight + fixTimeHeight * 2;

        // 到达底部
        if (bottom === 0) {
            this.getGlobalData();
        }

        try {
            const observer = new IntersectionObserver(
                changes => {
                    changes.filter(item => item.intersectionRatio > 0).forEach(change => {
                        const container = change.target;

                        const dateStr = container.getAttribute('data-newsdate');

                        if (dateStr && container.getBoundingClientRect().top <= boundingHeight) {
                            this.setState({
                                dateStr: getDateWeekDay(dateStr),
                            });
                        }
                    });
                },
                { threshold: 1 },
            );

            Array.from(this.ref.current.querySelectorAll('[data-newsdate]')).forEach(item => {
                observer.observe(item);
            });
        } catch (e) {
            console.error(e);
        }

        this.setState({
            scrollTop,
        });
    };

    /**
     * 请求
     */
    componentDidMount() {
        try {
            this.getClsData();
        } catch (err) {
            console.error(err);
        }

        let navId = getQuery(location.href, 'tabId');

        if (navId) {
            navId = parseInt(navId) && parseInt(navId) <= 2 ? parseInt(navId) : 1;
            this.setState({
                curId: navId,
            });
            this.handleTab(navId);
            this.addNavClass(navId);
        }

        try {
            const stickObserver = new IntersectionObserver(
                changes => {
                    changes.forEach(itemChange => {
                        this.setState({
                            stickShow: itemChange.intersectionRatio !== 1,
                        });
                    });
                },
                { threshold: 1 },
            );

            stickObserver.observe(document.getElementById('pageTabNav'));
        } catch (e) {
            console.error(e);
        }

        this.handleWindowScrollDebounce = debounce(this.handleScrollMore, 200);
        document.addEventListener('scroll', this.handleWindowScrollDebounce);

        const { time } = this.state;

        this.timer = setInterval(() => {
            this.refresh();
        }, time);
    }

    uniqueData = (data = []) => {
        return data.filter((item, index, self) => {
            return !self.slice(index + 1).some(other => {
                return other._brief === item._brief && other.ctime === item.ctime;
            });
        });
    };

    /**
     * 卸载定时器
     */
    componentWillUnmount() {
        clearInterval(this.timer);
    }

    /**
     * 初始化数据
     */
    getClsData = async () => {
        try {
            // const data = await getClsData(Date.parse(new Date()));
            const data = await getFinanceShareIdData();
            const len = data.data.length - 1;

            console.log(data.data, 'initData');

            this.setState({
                liveData: data.data,
                liveLastid: `${data.data[0].id}`,
                livePrevid: `${data.data[len].id}`,
            });
        } catch (e) {
            console.error(e);
        }
    };

    /**
     * 刷新数据
     */
    refresh = async () => {
        try {
            const { liveLastid } = this.state;

            // const data = await refreshClsData(liveLastid);
            const data = await getFinanceNewShareIdData(liveLastid);

            if (data) {
                const len = data.data.length - 1;

                const { liveData } = this.state;

                let newData = liveData.concat(data.data);

                newData = this.uniqueData(newData);
                newData = newData.sort(this.compare('ctime'));

                this.setState({
                    liveData: newData,
                    liveLastid: `${newData[0].id}`,
                    livePrevid: `${newData[len].id}`,
                });
            }
        } catch (e) {
            console.error(e);
        }
    };
    // 排序
    compare = p => {
        return function mySort(m, n) {
            const a = m[p];
            const b = n[p];

            return Number(b) - Number(a);
        };
    };
    /**
     * 更多数据
     */
    moreData = async () => {
        try {
            const { livePrevid } = this.state;
            // const data = await moreClsData(livePrevid);
            const data = await getFinanceMoreShareIdData(livePrevid);

            if (data) {
                const len = data.data.length - 1;

                const { liveData } = this.state;

                let newData = liveData.concat(data.data);

                newData = this.uniqueData(newData);
                newData = newData.sort(this.compare('ctime'));

                this.setState({
                    liveData: newData,
                    // liveLastid: `${data.data[0].id}`,
                    livePrevid: `${data.data[len].id}`,
                });
            }
        } catch (e) {
            console.error(e);
        }
    };

    addNavClass(index) {
        return index === this.state.curId ? `${styles.active}` : '';
    }

    goBack = () => {
        Grounds.close();
    };

    IS_IN_APP = typeof grounds !== 'undefined';

    render() {
        const { curId, tabNavArr, liveData, globalData, loading, stickShow, dateStr } = this.state;

        const isbox1Show = curId === 1 ? 'block' : 'none';
        const isbox2Show = curId === 2 ? 'block' : 'none';

        return (
            <div className={styles.tab_list} ref={this.ref}>
                <div ref={this.fixTabRef} className={`${styles.tabNavSticky} ${stickShow ? styles.stickShow : ''}`}>
                    {this.IS_IN_APP ? (
                        <span className={styles.stickyGoBack} onClick={this.goBack}>
                            &nbsp;
                        </span>
                    ) : null}
                    <ul>
                        {tabNavArr.map(item => {
                            return (
                                <li
                                    key={item.id}
                                    onClick={() => this.handleTab(item.id)}
                                    className={this.addNavClass(item.id)}>
                                    {item.name}
                                    <span>&nbsp;</span>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                {dateStr ? (
                    <div ref={this.fixTimeRef} className={`${styles.dateSticky} ${stickShow ? styles.stickShow : ''}`}>
                        <span>&nbsp;</span>
                        {dateStr}
                    </div>
                ) : null}
                <div className={`${styles.tab_nav}`} id="pageTabNav">
                    <ul>
                        {tabNavArr.map(item => {
                            return (
                                <li
                                    key={item.id}
                                    onClick={() => this.handleTab(item.id)}
                                    className={this.addNavClass(item.id)}>
                                    {item.name}
                                    <span>&nbsp;</span>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                <div style={{ display: isbox1Show }}>
                    {liveData.length !== 0 && <AllNews content={liveData} moreData={() => this.moreData()} />}
                </div>
                <div style={{ display: isbox2Show }}>
                    <GlobalNews content={globalData} />
                    {loading ? <div className={styles.loading} /> : null}
                </div>
            </div>
        );
    }
}
export default errorBoundary(TabList);
